export const MOBILE_MIN_HEIGHT_BREAKPOINTS = {
  SHORT: 574,
};
